var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpdBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 117,
    viewBox: "0 0 334 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5222_29699",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 334,
    height: 117
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 334,
    height: 117,
    rx: 12,
    fill: "#F0F2FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 333,
    height: 116,
    rx: 11.5,
    stroke: "url(#paint0_linear_5222_29699)",
    strokeOpacity: 0.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5222_29699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5 246C143.067 246 210 179.067 210 96.5C210 13.9334 143.067 -53 60.5 -53C-22.0666 -53 -89 13.9334 -89 96.5C-89 179.067 -22.0666 246 60.5 246Z",
    fill: "#DBD5F9",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 138C48.897 138 63 123.897 63 106.5C63 89.103 48.897 75 31.5 75C14.103 75 0 89.103 0 106.5C0 123.897 14.103 138 31.5 138Z",
    stroke: "url(#paint1_linear_5222_29699)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 135C47.2401 135 60 122.24 60 106.5C60 90.7599 47.2401 78 31.5 78C15.7599 78 3 90.7599 3 106.5C3 122.24 15.7599 135 31.5 135Z",
    stroke: "url(#paint2_linear_5222_29699)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 132C45.5833 132 57 120.583 57 106.5C57 92.4167 45.5833 81 31.5 81C17.4167 81 6 92.4167 6 106.5C6 120.583 17.4167 132 31.5 132Z",
    stroke: "url(#paint3_linear_5222_29699)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 129C43.9264 129 54 118.926 54 106.5C54 94.0736 43.9264 84 31.5 84C19.0736 84 9 94.0736 9 106.5C9 118.926 19.0736 129 31.5 129Z",
    stroke: "url(#paint4_linear_5222_29699)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 126C42.2696 126 51 117.27 51 106.5C51 95.7304 42.2696 87 31.5 87C20.7304 87 12 95.7304 12 106.5C12 117.27 20.7304 126 31.5 126Z",
    stroke: "url(#paint5_linear_5222_29699)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 123C40.6127 123 48 115.613 48 106.5C48 97.3873 40.6127 90 31.5 90C22.3873 90 15 97.3873 15 106.5C15 115.613 22.3873 123 31.5 123Z",
    stroke: "url(#paint6_linear_5222_29699)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 120C38.9558 120 45 113.956 45 106.5C45 99.0442 38.9558 93 31.5 93C24.0442 93 18 99.0442 18 106.5C18 113.956 24.0442 120 31.5 120Z",
    stroke: "url(#paint7_linear_5222_29699)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 117C37.299 117 42 112.299 42 106.5C42 100.701 37.299 96 31.5 96C25.701 96 21 100.701 21 106.5C21 112.299 25.701 117 31.5 117Z",
    stroke: "url(#paint8_linear_5222_29699)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 114C35.6421 114 39 110.642 39 106.5C39 102.358 35.6421 99 31.5 99C27.3579 99 24 102.358 24 106.5C24 110.642 27.3579 114 31.5 114Z",
    stroke: "url(#paint9_linear_5222_29699)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 111C33.9853 111 36 108.985 36 106.5C36 104.015 33.9853 102 31.5 102C29.0147 102 27 104.015 27 106.5C27 108.985 29.0147 111 31.5 111Z",
    stroke: "url(#paint10_linear_5222_29699)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 108C32.3284 108 33 107.328 33 106.5C33 105.672 32.3284 105 31.5 105C30.6716 105 30 105.672 30 106.5C30 107.328 30.6716 108 31.5 108Z",
    stroke: "url(#paint11_linear_5222_29699)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4637 196.747C115.654 196.747 160.394 152.007 160.394 96.8167C160.394 41.6269 115.654 -3.11328 60.4637 -3.11328C5.27387 -3.11328 -39.4663 41.6269 -39.4663 96.8167C-39.4663 152.007 5.27387 196.747 60.4637 196.747Z",
    stroke: "url(#paint12_linear_5222_29699)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7139 190.988C106.723 190.988 148.884 148.827 148.884 96.8184C148.884 44.8098 106.723 2.64844 54.7139 2.64844C2.70527 2.64844 -39.4561 44.8098 -39.4561 96.8184C-39.4561 148.827 2.70527 190.988 54.7139 190.988Z",
    stroke: "url(#paint13_linear_5222_29699)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6039 185.608C97.2381 185.608 136.664 146.182 136.664 97.5483C136.664 48.9141 97.2381 9.48828 48.6039 9.48828C-0.0302505 9.48828 -39.4561 48.9141 -39.4561 97.5483C-39.4561 146.182 -0.0302505 185.608 48.6039 185.608Z",
    stroke: "url(#paint14_linear_5222_29699)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7421 155.743C130.359 124.127 130.359 72.8656 98.7421 41.2487C67.1252 9.6319 15.8642 9.63187 -15.7526 41.2487C-47.3695 72.8656 -47.3695 124.127 -15.7526 155.743C15.8642 187.36 67.1253 187.36 98.7421 155.743Z",
    stroke: "url(#paint15_linear_5222_29699)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3539 172.288C75.1181 172.288 108.164 139.242 108.164 98.478C108.164 57.7138 75.1181 24.668 34.3539 24.668C-6.41019 24.668 -39.4561 57.7138 -39.4561 98.478C-39.4561 139.242 -6.41019 172.288 34.3539 172.288Z",
    stroke: "url(#paint16_linear_5222_29699)",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.038 13.4177C304.259 10.4764 301.244 8.72288 298.303 9.50111L277 15.1374C274.059 15.9156 272.306 18.9309 273.084 21.8721L278.72 43.1747L257.417 48.811C254.476 49.5892 252.723 52.6044 253.501 55.5457L259.137 76.8483C259.915 79.7897 262.931 81.5431 265.872 80.7649L287.174 75.1286L292.811 96.4313C293.589 99.3726 296.604 101.126 299.545 100.348L320.848 94.7116C323.789 93.9333 325.543 90.9182 324.765 87.9768L319.128 66.6742L340.431 61.038C343.372 60.2597 345.126 57.2446 344.348 54.3032L338.711 33.0006C337.933 30.0594 334.918 28.3058 331.977 29.084L310.674 34.7203L305.038 13.4177Z",
    stroke: "#747EDC",
    strokeOpacity: 0.17,
    strokeWidth: 7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5222_29699",
    x1: -4.69703e-7,
    y1: 2.925,
    x2: 258.651,
    y2: 210.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B48C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6AEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5222_29699",
    x1: 15.9852,
    y1: 117.392,
    x2: 81.0678,
    y2: 73.6484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5222_29699",
    x1: 17.4628,
    y1: 116.355,
    x2: 76.3471,
    y2: 76.7771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5222_29699",
    x1: 18.9404,
    y1: 115.318,
    x2: 71.6263,
    y2: 79.9059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5222_29699",
    x1: 20.418,
    y1: 114.28,
    x2: 66.9056,
    y2: 83.0346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5222_29699",
    x1: 21.8956,
    y1: 113.243,
    x2: 62.1848,
    y2: 86.1633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5222_29699",
    x1: 23.3732,
    y1: 112.206,
    x2: 57.4641,
    y2: 89.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5222_29699",
    x1: 24.8508,
    y1: 111.168,
    x2: 52.7434,
    y2: 92.4208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5222_29699",
    x1: 26.3284,
    y1: 110.131,
    x2: 48.0226,
    y2: 95.5495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5222_29699",
    x1: 27.806,
    y1: 109.093,
    x2: 43.3019,
    y2: 98.6782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5222_29699",
    x1: 29.2836,
    y1: 108.056,
    x2: 38.5811,
    y2: 101.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5222_29699",
    x1: 30.7612,
    y1: 107.019,
    x2: 33.8604,
    y2: 104.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5222_29699",
    x1: 11.2448,
    y1: 131.372,
    x2: 217.712,
    y2: -7.40102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5222_29699",
    x1: 8.332,
    y1: 129.382,
    x2: 202.898,
    y2: -1.39211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5222_29699",
    x1: 5.23139,
    y1: 127.999,
    x2: 187.174,
    y2: 5.70987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5222_29699",
    x1: 33.0942,
    y1: 146.488,
    x2: 71.8744,
    y2: -51.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5222_29699",
    x1: -2,
    y1: 124.001,
    x2: 150.5,
    y2: 21.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#714FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6544C6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpdBg);
export default __webpack_public_path__ + "static/media/OpdBg.c71bd9aa027da99dd98614e67d9b7b15.svg";
export { ForwardRef as ReactComponent };